import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useCurrentClient } from '../../../api/clients'

const useStyleVariant = (className, style, variant) => {
  return useMemo(() => {
    if (variant === 'wheel') {
      return [clsx(className, 'py-2 font-size-sm'), {
        fontWeight: 'var(--font-weight-thin)',
        maxWidth: '450px',
        textAlign: 'center',
        ...(style || {})
      }]
    }
    return [className, style]
  }, [className, style, variant])
}

const useDescription = (client) => {
  return useMemo(() => {
    return client?.description
  }, [client])
}

function CurrentClientWealthMission ({ className, style, variant }) {
  const { data: client, isLoading } = useCurrentClient()
  const description = useDescription(client)
  const [_className, _style] = useStyleVariant(className, style, variant)

  if (isLoading) {
    return null
  }

  return (
    <div className={_className} style={_style}>
      {description}
    </div>
  )
}

CurrentClientWealthMission.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.string
}

export default CurrentClientWealthMission
